<ng-container *ngIf="providerContracts$ | async as providerContracts">
  <ng-container *ngIf="consumerContracts$ | async as consumerContracts">
    <div id="wrapper" [style.height]="(providerContracts.length + consumerContracts.length) === 0 ? 'calc(100% - 98px)' : 'auto'">
      <div *ngIf="providerContracts.length === 0 && consumerContracts.length === 0" class="empty-wrapper">
        <div class="no-assets-message">
          <mat-icon style="font-size: 64px; width: 64px; height: 64px;">description</mat-icon>
          <h2>No contracts found</h2>
          <p>You don't have any active contracts yet.</p>
          <p>Browse the catalog and negotiate contracts to see them here.</p>
        </div>
      </div>
      <div style="display: flex; flex-direction: column; gap: 20px;">
        <mat-accordion *ngIf="providerContracts.length > 0 || consumerContracts.length > 0" class="contracts-accordion">
          <mat-expansion-panel *ngIf="providerContracts.length > 0" class="contracts-expansion-panel" expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="contracts-section-title">As Provider</mat-panel-title>
              <mat-panel-description>
                {{providerContracts.length}} contract<span *ngIf="providerContracts.length !== 1">s</span>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="cards-grid">
              <mat-card *ngFor="let contract of providerContracts" class="contract-card">
                <mat-card-header>
                  <mat-icon mat-card-avatar>description</mat-icon>
                  <mat-card-title>{{contract.id}}</mat-card-title>
                </mat-card-header>
                <mat-divider class="contract-header-divider"></mat-divider>
                <mat-card-content>
                  <div class="contract-properties">
                    <div class="contract-property-row">
                      <div class="contract-property-top">
                        <mat-icon>category</mat-icon>
                        <div class="contract-property-header">Asset</div>
                      </div>
                      <div class="contract-property-value">{{contract.assetId}}</div>
                    </div>

                    <div class="contract-property-row">
                      <div class="contract-property-top">
                        <mat-icon>person</mat-icon>
                        <div class="contract-property-header">Provider</div>
                      </div>
                      <div class="contract-property-value">{{contract.providerId}}</div>
                    </div>

                    <div class="contract-property-row">
                      <div class="contract-property-top">
                        <mat-icon>draw</mat-icon>
                        <div class="contract-property-header">Signing date</div>
                      </div>
                      <div class="contract-property-value">{{asDate(contract.mandatoryValue('edc', 'contractSigningDate'))}}</div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel style="margin-top: 20px;" *ngIf="consumerContracts.length > 0" class="contracts-expansion-panel" expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="contracts-section-title">As Consumer</mat-panel-title>
              <mat-panel-description>
                {{consumerContracts.length}} contract<span *ngIf="consumerContracts.length !== 1">s</span>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="cards-grid">
              <mat-card *ngFor="let contract of consumerContracts" class="contract-card">
                <mat-card-header>
                  <mat-icon mat-card-avatar>description</mat-icon>
                  <mat-card-title>{{contract.id}}</mat-card-title>
                </mat-card-header>
                <mat-divider class="contract-header-divider"></mat-divider>
                <mat-card-content>
                  <div class="contract-properties">
                    <div class="contract-property-row">
                      <div class="contract-property-top">
                        <mat-icon>category</mat-icon>
                        <div class="contract-property-header">Asset</div>
                      </div>
                      <div class="contract-property-value">{{contract.assetId}}</div>
                    </div>

                    <div class="contract-property-row">
                      <div class="contract-property-top">
                        <mat-icon>person</mat-icon>
                        <div class="contract-property-header">Provider</div>
                      </div>
                      <div class="contract-property-value">{{contract.providerId}}</div>
                    </div>

                    <div class="contract-property-row">
                      <div class="contract-property-top">
                        <mat-icon>draw</mat-icon>
                        <div class="contract-property-header">Signing date</div>
                      </div>
                      <div class="contract-property-value">{{asDate(contract.mandatoryValue('edc', 'contractSigningDate'))}}</div>
                    </div>
                  </div>
                </mat-card-content>

                <mat-card-footer class="contract-card-footer">
                  <button
                    (click)="onTransferClicked(contract)"
                    [disabled]="isTransferInProgress(contract.id!)"
                    class="transfer-button"
                    color="accent"
                    mat-flat-button>
                    <mat-icon>downloading</mat-icon>
                    Transfer
                  </button>
                  <mat-progress-bar *ngIf="isTransferInProgress(contract.id!)" color="accent" mode="indeterminate"></mat-progress-bar>
                </mat-card-footer>
              </mat-card>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </ng-container>
</ng-container>
